/* tslint:disable */
/* eslint-disable */
/**
 * Oasisscan API
 * https://github.com/bitcat365/oasisscan-backend#readme https://api.oasisscan.com/mainnet/swagger-ui/#/ https://api.oasisscan.com/mainnet/v2/api-docs 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DebondingDelegationRow,
    DebondingDelegationRowFromJSON,
    DebondingDelegationRowFromJSONTyped,
    DebondingDelegationRowToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse2005Data
 */
export interface InlineResponse2005Data {
    /**
     * 
     * @type {Array<DebondingDelegationRow>}
     * @memberof InlineResponse2005Data
     */
    list: Array<DebondingDelegationRow>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2005Data
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2005Data
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2005Data
     */
    maxPage: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2005Data
     */
    totalSize: number;
}

export function InlineResponse2005DataFromJSON(json: any): InlineResponse2005Data {
    return InlineResponse2005DataFromJSONTyped(json, false);
}

export function InlineResponse2005DataFromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse2005Data {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(DebondingDelegationRowFromJSON)),
        'page': json['page'],
        'size': json['size'],
        'maxPage': json['maxPage'],
        'totalSize': json['totalSize'],
    };
}

export function InlineResponse2005DataToJSON(value?: InlineResponse2005Data | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(DebondingDelegationRowToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize,
    };
}


